module.exports = __webpack_public_path__ + "static/media/Aptifer Slab-01.1bf898e6.svg";